import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

//Components
import TextField from '../../components/TextField/TextField';

//Api
import prefeitura_api from '../../api/prefeitura_api';

//Helpers
import { getSessionCookie } from '../../helpers/cookies';
import { showMessage } from '../../helpers/message';

export default function FiltroPrefeitura({ handleValue, item = [] }) {
    //Usuario logado no sistema
    const usuario = getSessionCookie();

    ///Estado de controle das opções de prefeitura para o ambiente privado
    const [prefeituras, setPrefeituras] = useState([
        { value: "", text: "Selecione" }
    ])

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);

    const handleChangePrefeitura = (value) => {
        setPrefeitura_Id(value);
        handleValue(value);
    }

    //Carrega a lista de prefeituras
    useEffect(() => {
        if (Object.keys(item).length > 0 && item?.prefeituras_Id != null && item?.prefeituras_Id > 0) {
            handleChangePrefeitura(item?.prefeituras_Id)
        }

        prefeitura_api.GetList().then(response => {
            if (!usuario || usuario.ambiente == "Público")
                handleChangePrefeitura(response.data[0].id);
            else {
                const _prefeituras = response.data.map(prefeitura => {
                    return { value: prefeitura.id.toString(), text: prefeitura.fantasia }
                })
                setPrefeituras([...prefeituras, ..._prefeituras]);
            }
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }, []);

    return (
        <>
            {usuario && usuario.ambiente == "Privado" ? 
                <Row className='mb-2'>
                    <Col md="12" lg="12">
                        <TextField label={"* Prefeitura"} type={"select"} options={prefeituras} value={prefeitura_Id} onChange={(e) => handleChangePrefeitura(e.target.value)} name="prefeitura" />
                    </Col>
                </Row> : <></>
            }
        </>
    )
}